import { ChallengeSaveError } from '../types';

export const isChallengeSaveError = (
  data: unknown
): data is ChallengeSaveError => {
  const typed = data as ChallengeSaveError;

  return !!typed.type;
};
